export default __webpack_public_path__ + "static/media/slide-image-2_1728x.23115480.jpg";